<mat-toolbar>
  <mat-toolbar-row>
    <div class="oo-toolbar-wrapper">
      @if (!titlePortal()) {
        <a class="fo-unstyled oo-header" routerLink="/main/competitionGroups">
          Oogaday
        </a>
      }

      <ng-template [cdkPortalOutlet]="titlePortal()"></ng-template>

      @if (!isMobile()) {
        <ng-template [cdkPortalOutlet]="bottomPortal()"></ng-template>
      }

      <button [matMenuTriggerFor]="menu" class="oo-profile-link">
        <img [ngSrc]="userImage() || '/images/person.webp'" height="40" width="40" alt="person image">
      </button>

      <mat-menu #menu="matMenu">
        <a mat-menu-item routerLink="/main/user/profile">
          <mat-icon>person_outline</mat-icon>
          <span>Account</span>
        </a>

        @if (isSuperAdmin() && !router.url.includes('tourManagement')) {
          <a mat-menu-item routerLink="/main/tourManagement">
            <mat-icon>admin_panel_settings</mat-icon>
            <span>Tour Management</span>
          </a>
        }

        @if (router.url.includes('tourManagement')) {
          <a mat-menu-item routerLink="/main/competitionGroups">
            <mat-icon>home</mat-icon>
            <span>Main Page</span>
          </a>
        }

        <mat-divider></mat-divider>

        <a (click)="logout.emit()" mat-menu-item>
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </a>
      </mat-menu>
    </div>
  </mat-toolbar-row>

  @if (isMobile()) {
    <mat-toolbar-row class="oo-second-row">
      <ng-template [cdkPortalOutlet]="bottomPortal()"></ng-template>
    </mat-toolbar-row>
  }
</mat-toolbar>
